import { UniDriver } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { DATA_HOOKS } from './LabelledElement.constants';

export const labelledElementDriverFactory = (base: UniDriver) => {
  const getLabel = () => base.$(`[data-hook="${DATA_HOOKS.label}"]`);

  return {
    ...baseUniDriverFactory(base),

    /** Gets the content of rendered label */
    getLabelText: () => getLabel().text(),

    /** Checks if position the label is positioned at thetop of the input element  */
    isLabelAtTop: async () => (await getLabel().attr('data-top')) === 'true',

    /** Gets the children container UniDriver */
    getChildren: () => base.$(`[data-hook="${DATA_HOOKS.childrenWrapper}"]`),
  };
};

export type LabelledElementUniDriver = ReturnType<
  typeof labelledElementDriverFactory
>;
